import React from "react";
import { useState } from "react";

import { Input, Modal, Row } from "antd";

import AssigneeSelect from "./AssigneeSelect";

interface CreateCustomerRuleModalProps {
  isModalOpen: boolean;
  onSubmit: (userId: string, userName: string, rule: string) => void;
  onCancel: () => void;
}

function CreateCustomerRuleModal({ onSubmit, onCancel, isModalOpen }: CreateCustomerRuleModalProps) {
  const [user, setUser] = useState<any>();
  const [ruleValue, setRuleValue] = useState<string>("");

  const handleCancel = () => {
    setUser(null);
    setRuleValue("");
    onCancel();
  };

  const handleCreateCustomerRule = () => {
    const { value: userId, label: username } = user;
    onSubmit(userId, username, ruleValue);
    setRuleValue("");
  };

  return (
    <Modal title="Create Customer Rule" open={isModalOpen} width={"600px"} onCancel={handleCancel} onOk={handleCreateCustomerRule}>
      <Row>
        <AssigneeSelect
          value={user}
          placeholder="Select DES"
          onChange={(newValue) => {
            setUser(newValue as any);
          }}
          style={{ width: "100%" }}
        />
      </Row>
      <Row justify="start" align="middle" style={{ marginTop: "10px" }}>
        <Input size="large" placeholder="Enter rule" value={ruleValue} onChange={(e) => setRuleValue(e.target.value)} />
      </Row>
    </Modal>
  );
}

export default CreateCustomerRuleModal;
